module.exports = __webpack_public_path__ + "img/pic_france_03.ef315b94.jpg";